export function compareItemLists(systemList, orderList) {
    let addedItems = [];
    let removedItems = [];

    let systemMap = new Map();
    systemList.forEach((item) => {
        systemMap.set(item?.Fielders_Code, item);
    });

    let orderMap = new Map();
    orderList.forEach((item) => {
        orderMap.set(item?.Fielders_Code, item);
    });

    // Check for items added or changed in the order list
    orderMap.forEach((orderItem, code) => {
        if (!systemMap.has(code)) {
            addedItems.push(orderItem);
        } else {
            let systemItem = systemMap.get(code);
            let orderQty = parseInt(orderItem.Qty, 10);
            let systemQty = parseInt(systemItem.Qty, 10);
            let diff = Math.abs(orderQty - systemQty).toString();

            if (orderQty > systemQty) {
                addedItems.push({ ...orderItem, Qty: diff });
            } else if (orderQty < systemQty) {
                removedItems.push({ ...orderItem, Qty: diff });
            }
        }
    });

    // Check for items removed from the system list
    systemMap.forEach((systemItem, code) => {
        if (!orderMap.has(code)) {
            removedItems.push(systemItem);
        }
    });

    return { addedItems, removedItems };
}
